import React, { useState } from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import banner from "../../../assets/kangaroo/AboutBanner.png";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import nepal from "../../../assets/kangaroo/nepalflag.png";
import australiaFlag from "../../../assets/kangaroo/newzealandflag.png";
import newZealandFlag from "../../../assets/kangaroo/newzealandflag.png";
import ukFlag from "../../../assets/kangaroo/newzealandflag.png";
import usaFlag from "../../../assets/kangaroo/canadaflag.png";
import chinaFlag from "../../../assets/kangaroo/newzealandflag.png";
import { Col, Container, Dropdown, Row } from "reactstrap";
import Smallbutton from "../../../component/button/Smallbutton";
import FormGoldBg from "../../../component/FormCloseGold/FormGoldBg";
import FormClosepink from "../../../component/FormClosePink/FormClosepink";
import Fullform from "../../../component/FullForm/Fullform";
import { useParams } from "react-router-dom";
import PageService from "../../../services/PageService";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../../../services/imageBaseApi";

const Franchise = () => {
  const [countryCode, setCountryCode] = useState(null);
  const [thankYouModal, setThankYouModal] = useState(false);
  const {page} = useParams()
  const toggleThankYou = () => setThankYouModal(!thankYouModal);
  const fetchData = async () => {
   const response = await PageService.getbySlug(page)
   return response
  };
  const {isLoading,error,data} = useQuery({
    queryKey: ["fetchData", page],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
  })
  return (
    <div>
      <div
        className="about-hero-banner"
        style={{ "--banner-img": `url(${imageBaseApi+ data?.featuredMedia?.url})`, marginBottom: "5.5rem" }}
      >
        <SectionContainer>
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "CORPORATE", link: "/" },
              { title: "FRANCHISE" },
            ]}
            instituition={true}
          />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1 className="font-level-4 lh-1" >
              BECOME OUR <br /> FRANCHISE
            </h1>
          </div>
        </SectionContainer>
      </div>
      <SectionContainer>
        <Container fluid>
          <Row>
            <Col>
              <p className="country-paragraph-text">
                If you’re interested in opening a Kangaroo Education Foundation
                office within Nepal, please fill out the form below, our team
                will reach out to guide you through the next steps.
              </p>
            </Col>
          </Row>
          <Fullform
            isFranchise={true}
            fullName={true}
            email={true}
            phone={true}
            prefreredLocation={true}
            message={true}
            closeFormat="pink"
            closingdesc="Thank you for your interest in partnering with Kangaroo Education Foundation. Our team will connect with you soon to discuss the next steps."
          />
        </Container>
      </SectionContainer>
    </div>
  );
};

export default Franchise;
